module.exports = __webpack_public_path__ + "static/media/dontStretch.f36903f3.svg";